import React from 'react'
import styled from 'styled-components'
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

function Header({user,signOut}) {
    return (
        <Container>
           <Main>
               <AccessTimeIcon />

                <SearchContainer>
                    <Search>
                        <input type="text" placeholder="Search..."/>
                    </Search>
                </SearchContainer>

               <HelpOutlineIcon />
           </Main>

           <UserContainer>

               <Name>
                   {user.name}
               </Name>
               
               <UserImage onClick={signOut}>
                   <img src= {user.photo ? user.photo : "https://imgur.com/6VBx3io.png" } />
               </UserImage>
           </UserContainer>
        </Container>
    )
}

export default Header

const Container = styled.div
`
background : #9424F0;
color : white;
display : flex;
align-items: center;
justify-content:center;
position:relative;
box-shadow:0 1px 0 0 rgb(225 225 225 / 10%);



`

const Main = styled.div
`
display : flex;
margin-left:16px;
margin-right:16px;

`

const SearchContainer = styled.div
`
min-width: 400px;
margin-left:16px;
margin-right:16px;
colour: white;

`

const Search = styled.div
`
box-shadow: inset 0 0 0 1px white;
width: 100%;
border-radius: 6px;
colour:white;


input
{
    background-color:transparent;
    border:none;
    padding-left:8px;
    padding-right:8px;
    color:white;
    padding-top:4px;
    padding-bottom:4px;
    ::placeholder { 
        color: white;
        opacity: 1;
      }
}
input:focus
{
    outline:none;
}
`
const UserContainer = styled.div
`
display:flex;
align-items: center;
padding-right:16px;
position:absolute;
right:0;


`
const Name = styled.div
`
padding-right:16px;
`
const UserImage = styled.div
`
height:28px;
width:28px;
border:1px solid white;
border-radius:2px;
img{
width:100%;
height:100%;
cursor:pointer;

}


`